import React, { useCallback, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Input, Button } from 'antd';
import * as loginApi from 'src/apis/login';
import { useDispatch } from 'react-redux';
import { Creators } from 'src/store/ducks/login';
import './style.scss'
import refreshTokenSemaphore from 'src/utils/Semaphore';

//TODO: fix after new auth
function LoginPage() {
    const dispatch = useDispatch();
    const [ email, setEmail ] = useState('');
    const history = useHistory();
    
    useEffect(() => {
        refreshTokenSemaphore.unlockTokenValidation();
    }, [])

    const onLogin = useCallback(async () => {
        const response = await loginApi.getMockToken(
            email.includes('@') ? email : `${email}@ciandt.com`
        ).then(
            localStorage.setItem('code-verifier', 'a1b17d9c841614e3f618eb519332bb3ed6518de7286ddcdb37d6afc5')
        ).catch(_err => {
            alert('Error');
        })

        if (response?.data?.statusCode === 200) {
            dispatch(Creators.setLogin(true));
            dispatch(Creators.setSessionUser({login: email.includes('@') ? email.split('@')[0] : email}));
            loginApi.getLoggedUser().then(response => {
                if(response.data.result) dispatch(Creators.setSessionUser(response.data.result));
                history.push('/');
            }).catch(_err => {
                window.location.href = '/unauthentication';
            })
            history.push('/');
        }
    }, [email, history, dispatch]);

    return (
        <div className="login-page">
            <div className="login-panel">
                <Input placeholder="E-mail" onPressEnter={onLogin} onChange={e => setEmail(e.target.value)} value={email} />
                <Button type="primary" onClick={onLogin}>Login</Button>
            </div>
        </div>
    );
}

export default LoginPage;
